module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1034-2dcf9c07ebd491ce42e44d02fceffbbd.png";